import * as React from "react"
import { SFProIcon, SFProIconProps } from "./SFProIcon"

export interface ViewIconProps extends Omit<SFProIconProps, 'symbol'> {}

/**
 * View icon using SF Pro font symbol (􀋭)
 *
 * This icon represents viewing or navigating to a collection in the ANYW3AR app.
 *
 * @example
 * ```tsx
 * <ViewIcon />
 * <ViewIcon size={16} weight="semibold" />
 * ```
 */
export const ViewIcon = React.forwardRef<HTMLSpanElement, ViewIconProps>(
  (props, ref) => {
    return <SFProIcon ref={ref} symbol="􀋭" {...props} />
  }
)

ViewIcon.displayName = "ViewIcon"
